import React from "react";
import { Redirect } from "react-router-dom";
import {
  PageSuspense,
  Dashboard,
  Cases,
  CaseDetail,
  BulkImport,
  ClientDetail,
  Clients,
} from "../lazyComponents";
import { wrapHeavyFeaturePage } from "../heavyRouteBoundary";
import type { AppRoute } from "../types";

export const dashboardCasesClientRoutes: AppRoute[] = [
  {
    path: "/search",
    main: () => (
      <PageSuspense>
        <Dashboard />
      </PageSuspense>
    ),
  },
  {
    path: "/cases",
    main: () => (
      <PageSuspense>
        <Cases />
      </PageSuspense>
    ),
  },
  {
    path: "/case-details/:case_id",
    main: wrapHeavyFeaturePage(
      () => (
        <PageSuspense>
          <CaseDetail />
        </PageSuspense>
      ),
      "CaseDetail"
    ),
  },
  {
    path: "/clients/bulk-import",
    main: () => (
      <PageSuspense>
        <BulkImport />
      </PageSuspense>
    ),
  },
  {
    path: "/clients/:clientId",
    main: wrapHeavyFeaturePage(
      () => (
        <PageSuspense>
          <ClientDetail />
        </PageSuspense>
      ),
      "ClientDetail"
    ),
  },
  {
    path: "/clients",
    main: () => (
      <PageSuspense>
        <Clients />
      </PageSuspense>
    ),
  },
  {
    path: "/client",
    main: () => <Redirect to="/clients" />,
  },
];
